export default {
    "dynamicFormsMain_forms": "Forms",
    "dynamicFormsMain_answers": "Answers"
}